import React, {PropsWithChildren, useCallback, useMemo, useState} from "react";
import {
    ProjectHeadingState,
    ProjectHeadingContext,
    ProjectHeadingContextProps
} from "./project-heading-context-props";

const ProjectHeadingProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [heading, setHeadingState] = useState<ProjectHeadingState>({});

    const setHeading = useCallback((next: ProjectHeadingState) => {
        setHeadingState(next);
    }, []);

    const clearHeading = useCallback(() => {
        setHeadingState({});
    }, []);

    const value = useMemo<ProjectHeadingContextProps>(
        () => ({ heading, setHeading, clearHeading }),
        [heading, setHeading, clearHeading],
    );

    return <ProjectHeadingContext.Provider value={value}>{children}</ProjectHeadingContext.Provider>;
};

export default ProjectHeadingProvider;